import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-tooltip.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/tooltip/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [style, tokens, host];
